import React from 'react';
import AuthPage from './AuthPage';

const SignInPage = () => <AuthPage mode="signin" />;

export default SignInPage;
